import React from "react"

function Preloader() {
  return (
    <div className="preloader">
      <h2 className="font-bold text-2xl">Loading ......</h2>
    </div>
  )
}

export default Preloader
